import API from './API.js'

export default class FailedUsersRooms extends API {
  constructor() {
    super('failed-users-rooms')
  }
}
